module.exports = __webpack_public_path__ + "media/images/bet__correctMarker@2x-2a6fb07e033a930f1fcf4fa78cf7d7a3.png";